<template>
  <MainLayout :initialDrawerExpanded="false" contentClass="pa-0" :has-sidebar="false">
    <template #header>
      <div class="overline">
        <PageBack />
      </div>
    </template>

    <template #content>
      <SupportHero compact title="Questions fréquentes" icon="mdi-frequently-asked-questions" />
      <div class="pa-4">
      <div class="faq-list mx-auto pa-2">

        <v-text-field v-model="q" label="Rechercher" prepend-inner-icon="mdi-magnify"
          outlined dense hide-details clearable class="mb-3" />

        <v-chip-group v-model="category" class="mb-4" active-class="primary--text">
          <v-chip :value="null" filter outlined>Toutes</v-chip>
          <v-chip v-for="c in categories" :key="c.id" :value="c.id" filter outlined>
            <v-icon left small>{{ c.icon }}</v-icon>{{ c.title }}
          </v-chip>
        </v-chip-group>

        <template v-if="items.length">
          <section v-for="g in groups" :key="g.id" class="mb-6">
            <h2 class="mb-3"><v-icon left color="primary">{{ g.icon }}</v-icon>{{ g.title }}</h2>
            <v-row>
              <v-col v-for="item in g.items" :key="item.slug" cols="12" md="6">
                <FaqCard :item="item" />
              </v-col>
            </v-row>
          </section>
        </template>
        <v-card v-else outlined class="pa-6 text-center">
          <p class="mb-3">Aucune réponse ne correspond à votre recherche.</p>
          <v-btn color="primary" elevation="0" :to="{ name: 'ticket_new' }">
            <v-icon left>mdi-plus</v-icon>Ouvrir un ticket
          </v-btn>
        </v-card>
      </div>
      </div>
    </template>
  </MainLayout>
</template>

<script>
import PageBack from '@/components/ui/PageBack.vue'
import MainLayout from '@/layout/MainLayout.vue'
import SupportHero from '@/components/support/SupportHero.vue'
import FaqCard from '@/components/support/FaqCard.vue'
import { FAQ_CATEGORIES, FAQ_ITEMS, searchFaq } from '@/content/faq'

export default {
  name: 'FaqListView',
  components: { PageBack, SupportHero, MainLayout, FaqCard },
  data() {
    const known = FAQ_CATEGORIES.some((c) => c.id === this.$route.query.category)
    return {
      q: this.$route.query.q || '',
      category: known ? this.$route.query.category : null,
      categories: FAQ_CATEGORIES,
    }
  },
  computed: {
    items() {
      const inCategory = this.category ? FAQ_ITEMS.filter((i) => i.category === this.category) : FAQ_ITEMS
      return searchFaq(this.q, inCategory)
    },
    groups() {
      return this.categories
        .map((c) => ({ ...c, items: this.items.filter((i) => i.category === c.id) }))
        .filter((g) => g.items.length)
    },
  },
}
</script>

<style scoped>
.faq-list {
  max-width: 1000px;
}
</style>
